import { contentTypes } from 'ggApp/modules/contentful/models/contentTypes';
import { mapCfEntityToCfMarketingCard } from './mapper';

export class CfMarketingCard {
    static contentType = contentTypes.CfMarketingCard;

    static mapCfEntity = mapCfEntityToCfMarketingCard;

    static get config() {
        return {
            contentType: this.contentType,
        };
    }

    constructor(props = {}) {
        const {
            cardTitle: title,
            cardDescription: description,
            cardCtaText: ctaText,
            ctaLink,
            cardImage: image,
        } = props;
        this.data = { title, description, ctaText, ctaLink, image };
    }
}
